// extracted by mini-css-extract-plugin
export default {"column":"tableHeader_column__jN94u","columnHandle":"tableHeader_columnHandle__fw2QZ","dragging":"tableHeader_dragging__xRjId"};